(() => {



  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];



  const body=document.body, overlay=$('[data-overlay]');







  // Shopify wraps header sections; make that wrapper sticky so the whole 2-row header stays fixed.



  const stickyHeader=$('[data-header].pp-header--sticky');



  if(stickyHeader){



    const stickyHost=stickyHeader.closest('.shopify-section');



    if(stickyHost){



      stickyHost.classList.add('pp-sticky-host');



      stickyHost.style.position='sticky';



      stickyHost.style.top='0px';



      stickyHost.style.zIndex='1100';



      stickyHost.style.overflow='visible';



      const syncSticky=()=>stickyHost.classList.toggle('is-scrolled',window.scrollY>8);



      syncSticky();



      window.addEventListener('scroll',syncSticky,{passive:true});



    }



  }



  const money=(cents)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'es-MX',{style:'currency',currency:(window.PetPaw.currency||'MXN')}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)}};



  const lock=(on)=>body.classList.toggle('is-locked',on);



  const setOverlay=(on)=>{if(!overlay)return; overlay.hidden=!on;};



  const closeAll=()=>{closeSearch();closeMobile();closeCart();closeFilters();};



  overlay?.addEventListener('click',closeAll);







  // Motion



  if(window.PetPaw.enableReveal && window.matchMedia('(prefers-reduced-motion: reduce)').matches===false) body.classList.add('pp-motion');



  if('IntersectionObserver'in window && body.classList.contains('pp-motion')){



    const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.08,rootMargin:'0px 0px -4%'});



    $$('[data-reveal]').forEach(el=>io.observe(el));



  } else $$('[data-reveal]').forEach(el=>el.classList.add('is-visible'));







  // Announcement



  $$('[data-announcement]').forEach(root=>{



    const items=$$('[data-announcement-item]',root); if(items.length<2||root.dataset.autoplay!=='true')return;



    let i=0; const ms=parseInt(root.dataset.interval||'5000',10);



    setInterval(()=>{items[i].classList.remove('is-active');i=(i+1)%items.length;items[i].classList.add('is-active')},ms);



  });







    // Search drawer + predictive search

  const searchDrawer=$('[data-search-drawer]'), searchInput=$('[data-predictive-search-input]'), searchResults=$('[data-predictive-search-results]');



  function openSearch(){if(!searchDrawer)return;closeMobile();closeCart();searchDrawer.classList.add('is-open');searchDrawer.setAttribute('aria-hidden','false');setOverlay(true);lock(true);setTimeout(()=>searchInput?.focus(),80)}

  function closeSearch(){if(!searchDrawer)return;searchDrawer.classList.remove('is-open');searchDrawer.setAttribute('aria-hidden','true');if(!$('.pp-mobile-menu.is-open')&&!$('.pp-cart-drawer.is-open')&&!$('.pp-filters.is-open')){setOverlay(false);lock(false)}}



  $$('[data-search-open]').forEach(b=>b.addEventListener('click',openSearch));

  $('[data-search-close]')?.addEventListener('click',closeSearch);

  document.addEventListener('keydown',e=>{if((e.metaKey||e.ctrlKey)&&e.key.toLowerCase()==='k'){e.preventDefault();openSearch()}if(e.key==='Escape')closeAll()});



  // PetPaw smart predictive search: separate strong matches from related results

  // and do not present cat products as a match for an explicit dog query (or vice versa).

  const DOG_TERMS=['perro','perros','perra','perras','perrito','perritos','cachorro','cachorros','canino','canina','caninos','caninas','canine','dog','dogs'];

  const CAT_TERMS=['gato','gatos','gata','gatas','gatito','gatitos','felino','felina','felinos','felinas','feline','cat','cats'];

  const SEARCH_STOP_WORDS=new Set(['para','de','del','la','las','el','los','un','una','unos','unas','con','sin','por','en','y','o','a','al','kg','kgs']);

  const PET_TERMS=new Set([...DOG_TERMS,...CAT_TERMS]);



  const normalizeSearchText=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9\s.-]/g,' ').replace(/\s+/g,' ').trim();



  function detectPetIntent(value){

    const words=new Set(normalizeSearchText(value).split(/\s+/).filter(Boolean));

    const dog=DOG_TERMS.some(term=>words.has(term));

    const cat=CAT_TERMS.some(term=>words.has(term));

    if(dog&&!cat)return'dog';

    if(cat&&!dog)return'cat';

    return'';

  }



  function getImportantSearchTerms(query){

    return normalizeSearchText(query).split(/\s+/).filter(term=>term&&term.length>1&&!SEARCH_STOP_WORDS.has(term)&&!PET_TERMS.has(term));

  }



  function getProductSearchText(card){

    return normalizeSearchText([card.dataset.title||'',card.dataset.vendor||'',card.dataset.type||'',card.dataset.tags||''].join(' '));

  }



  function productConflictsWithPet(card,petIntent){

    if(!petIntent)return false;

    const productPet=detectPetIntent(getProductSearchText(card));

    return Boolean(productPet&&productPet!==petIntent);

  }



  function isStrongProductMatch(card,importantTerms){

    if(!importantTerms.length)return false;

    const searchable=getProductSearchText(card);

    return importantTerms.every(term=>searchable.includes(term));

  }



  function createPredictiveSection(label,cards){

    const section=document.createElement('div');

    section.className='pp-predictive__section';

    const heading=document.createElement('div');

    heading.className='pp-predictive__label';

    heading.textContent=label;

    const products=document.createElement('div');

    products.className='pp-predictive__products';

    cards.forEach(card=>{card.hidden=false;products.appendChild(card)});

    section.appendChild(heading);

    section.appendChild(products);

    return section;

  }



  function addWhatsAppHelp(notice,query){

    const whatsappBase=searchDrawer?.dataset.searchWhatsapp||'';

    if(!whatsappBase)return;

    const separator=whatsappBase.includes('?')?'&':'?';

    const message=`Hola, estoy buscando "${query}" en PetPaw y no encuentro el producto. ¿Me pueden ayudar?`;

    const link=document.createElement('a');

    link.className='pp-predictive__whatsapp';

    link.href=`${whatsappBase}${separator}text=${encodeURIComponent(message)}`;

    link.target='_blank';

    link.rel='noopener';

    link.textContent='¿No encuentras el producto? Escríbenos por WhatsApp';

    notice.appendChild(link);

  }



  function organizePredictiveResults(query){

    if(!searchResults)return;

    const root=searchResults.querySelector('[data-predictive-root]');

    if(!root)return;



    const originalSection=root.querySelector('[data-predictive-product-section]');

    const notice=root.querySelector('[data-predictive-notice]');

    const cards=[...root.querySelectorAll('[data-predictive-product]')];

    const petIntent=detectPetIntent(query);

    const importantTerms=getImportantSearchTerms(query);

    const compatibleCards=cards.filter(card=>!productConflictsWithPet(card,petIntent));

    const exactMatches=compatibleCards.filter(card=>isStrongProductMatch(card,importantTerms));

    const relatedProducts=compatibleCards.filter(card=>!exactMatches.includes(card));



    if(notice){notice.innerHTML='';notice.hidden=true}



    if(!originalSection){

      if(notice){

        notice.hidden=false;

        const text=document.createElement('span');

        text.textContent=`No encontramos productos para “${query}”.`;

        notice.appendChild(text);

        addWhatsAppHelp(notice,query);

      }

      return;

    }



    const fragment=document.createDocumentFragment();

    if(exactMatches.length){

      fragment.appendChild(createPredictiveSection('Coincidencias',exactMatches.slice(0,5)));

      if(relatedProducts.length)fragment.appendChild(createPredictiveSection('También te puede interesar',relatedProducts.slice(0,4)));

    }else{

      if(notice){

        notice.hidden=false;

        const text=document.createElement('span');

        text.textContent=`No encontramos una coincidencia exacta para “${query}”.`;

        notice.appendChild(text);

        addWhatsAppHelp(notice,query);

      }

      if(relatedProducts.length){

        let label='Productos relacionados';

        if(petIntent==='dog')label='Productos relacionados para perros';

        if(petIntent==='cat')label='Productos relacionados para gatos';

        fragment.appendChild(createPredictiveSection(label,relatedProducts.slice(0,5)));

      }

    }

    originalSection.replaceWith(fragment);

  }



  let searchTimer,searchController;

  searchInput?.addEventListener('input',()=>{

    clearTimeout(searchTimer);

    const q=searchInput.value.trim();

    if(q.length<2){searchResults.innerHTML='';return}

    searchTimer=setTimeout(async()=>{

      try{

        searchController?.abort();

        searchController=new AbortController();

        searchResults.innerHTML='<div class="pp-predictive__label">Buscando…</div>';

        const url=`${window.PetPaw.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;

        const r=await fetch(url,{signal:searchController.signal});

        if(!r.ok)throw new Error(`Predictive search ${r.status}`);

        const txt=await r.text();

        const doc=new DOMParser().parseFromString(txt,'text/html');

        searchResults.innerHTML=doc.querySelector('#shopify-section-predictive-search')?.innerHTML||txt;

        organizePredictiveResults(q);

      }catch(e){

        if(e.name!=='AbortError')searchResults.innerHTML='<p>No pudimos cargar las sugerencias.</p>';

      }

    },180);

  });



// Mobile menu



  const mobile=$('[data-mobile-menu]');



  function openMobile(){if(!mobile)return;closeSearch();closeCart();mobile.classList.add('is-open');mobile.setAttribute('aria-hidden','false');setOverlay(true);lock(true)}



  function closeMobile(){if(!mobile)return;mobile.classList.remove('is-open');mobile.setAttribute('aria-hidden','true');if(!$('.pp-search-drawer.is-open')&&!$('.pp-cart-drawer.is-open')&&!$('.pp-filters.is-open')){setOverlay(false);lock(false)}}



  $('[data-mobile-menu-open]')?.addEventListener('click',openMobile);$('[data-mobile-menu-close]')?.addEventListener('click',closeMobile);







  // Cart drawer
  const cartDrawer=$('[data-cart-drawer]'),
        cartItems=$('[data-cart-drawer-items]'),
        cartFooter=$('[data-cart-drawer-footer]'),
        cartRecommendations=$('[data-cart-recommendations]'),
        cartRecommendationsList=$('[data-cart-recommendations-list]'),
        cartRecommendationsCopy=$('[data-cart-recommendations-copy]'),
        checkoutButton=$('[data-cart-checkout]');

  let cartRecommendationToken=0;

  function openCart(){
    if(!cartDrawer)return;
    closeSearch();
    closeMobile();
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden','false');
    setOverlay(true);
    lock(true);
    refreshCart();
  }

  function closeCart(){
    if(!cartDrawer)return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden','true');
    if(!$('.pp-search-drawer.is-open')&&!$('.pp-mobile-menu.is-open')&&!$('.pp-filters.is-open')){
      setOverlay(false);
      lock(false);
    }
  }

  $$('[data-cart-open]').forEach(b=>b.addEventListener('click',openCart));
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-cart-close]')||e.target.closest('[data-cart-continue]')){
      closeCart();
    }
  });

  const escapeHtml=value=>String(value??'')
    .replace(/&/g,'&amp;')
    .replace(/</g,'&lt;')
    .replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;')
    .replace(/'/g,'&#039;');

  async function refreshCart(){
    try{
      const r=await fetch(`${window.PetPaw.routes.cart}.js`,{headers:{Accept:'application/json'}});
      if(!r.ok)throw new Error(`Cart ${r.status}`);
      const cart=await r.json();
      renderCart(cart);
      return cart;
    }catch(e){
      return null;
    }
  }

  function renderCart(cart){
    $$('[data-cart-count]').forEach(el=>{
      el.textContent=cart.item_count;
      el.hidden=cart.item_count===0;
    });

    if(!cartItems)return;

    if(!cart.item_count){
      cartItems.innerHTML='<div class="pp-cart-empty"><p>Tu carrito está vacío.</p><a class="pp-button" href="/collections/all">Explorar productos</a></div>';
      if(cartFooter)cartFooter.hidden=true;
      if(cartRecommendations)cartRecommendations.hidden=true;
    }else{
      cartItems.innerHTML=cart.items.map((item,index)=>`
        <div class="pp-cart-item">
          <a class="pp-cart-item__image" href="${item.url}">
            ${item.image?`<img src="${item.image}${item.image.includes('?')?'&':'?'}width=180" alt="${escapeHtml(item.product_title)}">`:''}
          </a>
          <div class="pp-cart-item__meta">
            <a href="${item.url}">${escapeHtml(item.product_title)}</a>
            ${item.variant_title&&item.variant_title!=='Default Title'?`<small>${escapeHtml(item.variant_title)}</small>`:''}
            <div class="pp-cart-item__qty">
              <button type="button" data-cart-change="${index+1}" data-qty="${Math.max(0,item.quantity-1)}" aria-label="Disminuir">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-change="${index+1}" data-qty="${item.quantity+1}" aria-label="Aumentar">+</button>
            </div>
            <button class="pp-cart-item__remove" type="button" data-cart-change="${index+1}" data-qty="0">Eliminar</button>
          </div>
          <div class="pp-cart-item__price">${money(item.final_line_price)}</div>
        </div>
      `).join('');

      if(cartFooter){
        cartFooter.hidden=false;
        const subtotal=$('[data-cart-subtotal]');
        if(subtotal)subtotal.textContent=money(cart.total_price);
      }

      if(checkoutButton){
        checkoutButton.textContent=`IR AL CHECKOUT · ${money(cart.total_price)}`;
      }
    }

    const threshold=parseInt($('[data-free-shipping-wrap]')?.dataset.threshold||'59900',10);
    const bar=$('[data-free-shipping-bar]');
    const text=$('[data-free-shipping-text]');

    if(bar)bar.style.width=`${Math.min(100,(cart.total_price/threshold)*100)}%`;
    if(text){
      text.textContent=cart.total_price>=threshold
        ?'🎉 ¡Ya tienes envío gratis!'
        :`Te faltan ${money(threshold-cart.total_price)} para envío gratis.`;
    }

    renderCartRecommendations(cart,threshold);
  }

  function productImage(product){
    if(!product)return '';
    if(typeof product.featured_image==='string')return product.featured_image;
    if(product.featured_image?.url)return product.featured_image.url;
    if(product.images?.length){
      const first=product.images[0];
      return typeof first==='string'?first:(first?.src||first?.url||'');
    }
    return '';
  }

  function isSafeImpulseProduct(product){
    const haystack=[
      product?.title||'',
      product?.product_type||'',
      Array.isArray(product?.tags)?product.tags.join(' '):(product?.tags||'')
    ].join(' ').toLowerCase();

    const blocked=[
      'apoquel','nexgard','simparica','bravecto','rimadyl','immiticide',
      'librela','semintra','prednis','meloxicam','carprofen','farmacia',
      'medicamento','medicamentos','antiparasitario','antibiótico','antibiotico'
    ];

    return !blocked.some(term=>haystack.includes(term));
  }

  async function renderCartRecommendations(cart,threshold){
    const token=++cartRecommendationToken;

    if(!cartRecommendations||!cartRecommendationsList){
      return;
    }

    if(!cart?.item_count||!cart.items?.length){
      cartRecommendations.hidden=true;
      cartRecommendationsList.innerHTML='';
      return;
    }

    const anchor=cart.items[0];
    if(!anchor?.product_id){
      cartRecommendations.hidden=true;
      return;
    }

    cartRecommendations.hidden=false;
    cartRecommendationsList.innerHTML='<div class="pp-cart-recs__loading">Buscando opciones para completar tu compra…</div>';

    const remaining=Math.max(0,threshold-cart.total_price);
    if(cartRecommendationsCopy){
      cartRecommendationsCopy.textContent=remaining>0
        ?`Te faltan ${money(remaining)} para el envío gratis. Estas opciones pueden ayudarte a completarlo.`
        :'Ya tienes envío gratis. Puedes agregar algo más antes de finalizar.';
    }

    try{
      const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      const url=`${root}recommendations/products.json?product_id=${encodeURIComponent(anchor.product_id)}&limit=10&intent=related`;
      const r=await fetch(url,{headers:{Accept:'application/json'}});
      if(!r.ok)throw new Error(`Recommendations ${r.status}`);

      const data=await r.json();
      if(token!==cartRecommendationToken)return;

      const inCart=new Set(cart.items.map(item=>Number(item.product_id)));
      let candidates=(data.products||[])
        .filter(product=>product&&product.available&&!inCart.has(Number(product.id))&&isSafeImpulseProduct(product))
        .map(product=>{
          const variant=(product.variants||[]).find(v=>v.available);
          return variant?{product,variant,price:Number(variant.price||product.price||0)}:null;
        })
        .filter(Boolean);

      if(remaining>0){
        const maxImpulse=Math.max(35000,remaining*2);
        const affordable=candidates.filter(x=>x.price>0&&x.price<=maxImpulse);
        if(affordable.length>=3)candidates=affordable;

        candidates.sort((a,b)=>{
          const da=Math.abs(a.price-remaining);
          const db=Math.abs(b.price-remaining);
          return da-db;
        });
      }

      const picks=candidates.slice(0,3);

      if(!picks.length){
        cartRecommendations.hidden=true;
        cartRecommendationsList.innerHTML='';
        return;
      }

      cartRecommendationsList.innerHTML=picks.map(({product,variant,price})=>{
        const image=productImage(product);
        const url=product.url||`/products/${product.handle}`;
        return `
          <article class="pp-cart-rec">
            <a class="pp-cart-rec__image" href="${url}">
              ${image?`<img src="${image}${image.includes('?')?'&':'?'}width=240" alt="${escapeHtml(product.title)}" loading="lazy">`:''}
            </a>
            <div class="pp-cart-rec__meta">
              <a class="pp-cart-rec__title" href="${url}">${escapeHtml(product.title)}</a>
              <strong>${money(price)}</strong>
              <form data-quick-add-form>
                <input type="hidden" name="id" value="${variant.id}">
                <input type="hidden" name="quantity" value="1">
                <button class="pp-cart-rec__add" type="submit">
                  <span>+ Agregar</span>
                </button>
              </form>
            </div>
          </article>
        `;
      }).join('');
    }catch(e){
      if(token!==cartRecommendationToken)return;
      cartRecommendations.hidden=true;
      cartRecommendationsList.innerHTML='';
    }
  }

  document.addEventListener('click',async e=>{
    const btn=e.target.closest('[data-cart-change]');
    if(!btn)return;
    btn.disabled=true;
    try{
      const r=await fetch(`${window.PetPaw.routes.cartChange}.js`,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({
          line:Number(btn.dataset.cartChange),
          quantity:Number(btn.dataset.qty)
        })
      });
      if(!r.ok)throw new Error(`Cart change ${r.status}`);
      renderCart(await r.json());
    }catch(e){
    }finally{
      btn.disabled=false;
    }
  });

  // Quick add and product forms



  document.addEventListener('submit',async e=>{const form=e.target.closest('[data-quick-add-form], [data-product-form]');if(!form)return;e.preventDefault();const submit=form.querySelector('[type="submit"]');if(submit){submit.disabled=true;submit.dataset.originalHtml=submit.innerHTML;submit.textContent='Agregando…'}try{const fd=new FormData(form);const r=await fetch(`${window.PetPaw.routes.cartAdd}.js`,{method:'POST',headers:{Accept:'application/json'},body:fd});if(!r.ok)throw new Error('add');await refreshCart();openCart()}catch(err){alert('No pudimos agregar este producto. Intenta nuevamente.')}finally{if(submit){submit.disabled=false;submit.innerHTML=submit.dataset.originalHtml||'Agregar al carrito'}}});








  // Direct checkout button on product pages
  function initBuyNowButtons(scope=document){
    $$('[data-product-form]',scope).forEach(form=>{
      if(form.querySelector('[data-buy-now]'))return;

      const buyRow=form.querySelector('.pp-product-buy-row');
      const addButton=form.querySelector('[data-add-to-cart]');
      if(!buyRow||!addButton)return;

      const buyNow=document.createElement('button');
      buyNow.type='button';
      buyNow.className='pp-buy-now';
      buyNow.setAttribute('data-buy-now','');
      buyNow.textContent='Comprar ahora';
      buyNow.disabled=addButton.disabled;

      buyRow.insertAdjacentElement('afterend',buyNow);

      const select=form.querySelector('[data-variant-select]');
      select?.addEventListener('change',()=>{
        requestAnimationFrame(()=>{buyNow.disabled=addButton.disabled});
      });
    });
  }

  document.addEventListener('click',async e=>{
    const button=e.target.closest('[data-buy-now]');
    if(!button)return;

    const form=button.closest('[data-product-form]');
    if(!form||button.disabled)return;

    button.disabled=true;
    const original=button.textContent;
    button.textContent='Preparando compra…';

    try{
      const fd=new FormData(form);
      const r=await fetch(`${window.PetPaw.routes.cartAdd}.js`,{
        method:'POST',
        headers:{Accept:'application/json'},
        body:fd
      });

      if(!r.ok)throw new Error(`Buy now ${r.status}`);
      window.location.assign('/checkout');
    }catch(err){
      button.disabled=false;
      button.textContent=original;
      alert('No pudimos iniciar el checkout. Intenta nuevamente.');
    }
  });

  initBuyNowButtons(document);
  document.addEventListener('shopify:section:load',e=>initBuyNowButtons(e.target));

  // Quantity controls



  document.addEventListener('click',e=>{const minus=e.target.closest('[data-qty-minus]'),plus=e.target.closest('[data-qty-plus]');if(!minus&&!plus)return;const root=(minus||plus).closest('[data-product-form]'),input=$('[data-qty-input]',root);if(!input)return;const v=Math.max(1,Number(input.value||1)+(plus?1:-1));input.value=v});







  // Variant price update



  $$('[data-product-root]').forEach(root=>{const json=$('[data-product-json]',root),select=$('[data-variant-select]',root);if(!json||!select)return;let product;try{product=JSON.parse(json.textContent)}catch(e){return}select.addEventListener('change',()=>{const v=product.variants.find(x=>String(x.id)===select.value);if(!v)return;const price=$('[data-product-price]',root),button=$('[data-add-to-cart]',root);if(price)price.innerHTML=`${v.compare_at_price&&v.compare_at_price>v.price?`<s>${money(v.compare_at_price)}</s>`:''}<strong>${money(v.price)}</strong>`;if(button){button.disabled=!v.available;button.textContent=v.available?'Agregar al carrito':'Agotado'};if(history.replaceState){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}})});







  // Collection filters



  const filters=$('[data-filter-panel]');



  function openFilters(){if(!filters)return;filters.classList.add('is-open');setOverlay(true);lock(true)}function closeFilters(){if(!filters)return;filters.classList.remove('is-open');if(!$('.pp-search-drawer.is-open')&&!$('.pp-mobile-menu.is-open')&&!$('.pp-cart-drawer.is-open')){setOverlay(false);lock(false)}}



  $('[data-filter-open]')?.addEventListener('click',openFilters);$('[data-filter-close]')?.addEventListener('click',closeFilters);$('[data-sort-select]')?.addEventListener('change',e=>e.target.form.submit());



})();







(() => {



  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];



  const body=document.body, overlay=$('[data-overlay]');



  const money=(cents)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'es-MX',{style:'currency',currency:(window.PetPaw.currency||'MXN')}).format(Number(cents||0)/100)}catch(e){return '$'+(Number(cents||0)/100).toFixed(2)}};







  // Mega menu tabs (desktop)



  $$('[data-mega-root]').forEach(root=>{



    const tabs=$$('[data-mega-tab]',root), panels=$$('[data-mega-panel]',root);



    const item=root.closest('.pp-nav__item--pets');



    const trigger=item?.querySelector('.pp-nav__mega-trigger');



    const activate=id=>{



      tabs.forEach(t=>{const active=t.dataset.megaTab===id;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',active?'true':'false')});



      panels.forEach(p=>p.classList.toggle('is-active',p.dataset.megaPanel===id));



    };



    tabs.forEach(tab=>{tab.addEventListener('mouseenter',()=>activate(tab.dataset.megaTab));tab.addEventListener('focus',()=>activate(tab.dataset.megaTab));tab.addEventListener('click',()=>activate(tab.dataset.megaTab))});



    if(item&&trigger){



      item.addEventListener('mouseenter',()=>trigger.setAttribute('aria-expanded','true'));



      item.addEventListener('mouseleave',()=>{if(!item.classList.contains('is-manual-open'))trigger.setAttribute('aria-expanded','false')});



      trigger.addEventListener('click',e=>{e.preventDefault();const open=item.classList.toggle('is-manual-open');trigger.setAttribute('aria-expanded',open?'true':'false')});



      document.addEventListener('click',e=>{if(!item.contains(e.target)){item.classList.remove('is-manual-open');trigger.setAttribute('aria-expanded','false')}});



      item.addEventListener('keydown',e=>{if(e.key==='Escape'){item.classList.remove('is-manual-open');trigger.setAttribute('aria-expanded','false');trigger.focus()}});



    }



  });







  // Reusable horizontal sliders



  document.addEventListener('click',e=>{



    const prev=e.target.closest('[data-slider-prev]'), next=e.target.closest('[data-slider-next]');



    if(!prev&&!next)return;



    const section=(prev||next).closest('section'), track=$('[data-product-slider]',section);



    if(!track)return;



    track.scrollBy({left:(next?1:-1)*Math.max(280,track.clientWidth*.82),behavior:'smooth'});



  });







  // Variant pills on product cards



  document.addEventListener('click',e=>{



    const pill=e.target.closest('[data-card-variant]'); if(!pill||pill.classList.contains('is-disabled'))return;



    const card=pill.closest('[data-product-card]'); if(!card)return;



    $$('[data-card-variant]',card).forEach(x=>x.classList.remove('is-active'));pill.classList.add('is-active');



    const id=$('[data-card-variant-input]',card), selected=$('[data-card-selected]',card), price=$('[data-card-price]',card), add=$('[data-card-add]',card);



    if(id)id.value=pill.dataset.variantId;



    if(selected)selected.textContent=pill.textContent.trim();



    const p=Number(pill.dataset.variantPrice||0), cp=Number(pill.dataset.variantCompare||0);



    if(price)price.innerHTML=`${cp>p?`<s>${money(cp)}</s>`:''}<strong>${money(p)}</strong>`;



    const available=pill.dataset.variantAvailable==='true';



    if(add){add.disabled=!available;const span=$('span',add);if(span)span.textContent=available?'Añadir al carrito':'Agotado'};



  });







  // Lightweight device-local wishlist (no app required)



  const KEY='petpaw_wishlist_v1';



  const read=()=>{try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}};



  const write=items=>{try{localStorage.setItem(KEY,JSON.stringify(items))}catch(e){}};



  const drawer=$('[data-wishlist-drawer]'), itemsEl=$('[data-wishlist-items]');



  const sync=()=>{



    const items=read(), handles=new Set(items.map(i=>i.handle));



    $$('[data-wishlist-count]').forEach(el=>{el.textContent=items.length;el.hidden=items.length===0});



    $$('[data-wishlist-toggle]').forEach(btn=>{const on=handles.has(btn.dataset.productHandle);btn.classList.toggle('is-active',on);btn.setAttribute('aria-pressed',on?'true':'false')});



    if(itemsEl){itemsEl.innerHTML=items.length?items.map(i=>`<div class="pp-wishlist-item"><a href="${i.url}">${i.image?`<img src="${i.image}" alt="">`:''}</a><div class="pp-wishlist-item__meta"><a href="${i.url}">${i.title}</a><strong>${money(i.price)}</strong></div><button class="pp-wishlist-item__remove" type="button" data-wishlist-remove="${i.handle}" aria-label="Eliminar">×</button></div>`).join(''):'<div class="pp-wishlist-empty"><p>Aún no has guardado productos.</p><small>Toca el corazón de cualquier producto para verlo aquí.</small></div>'}



  };



  const open=()=>{if(!drawer)return;sync();drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');if(overlay)overlay.hidden=false;body.classList.add('is-locked')};



  const close=()=>{if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');if(!document.querySelector('.pp-search-drawer.is-open,.pp-mobile-menu.is-open,.pp-cart-drawer.is-open,.pp-filters.is-open')){if(overlay)overlay.hidden=true;body.classList.remove('is-locked')}};



  $$('[data-wishlist-open]').forEach(b=>b.addEventListener('click',open)); $('[data-wishlist-close]')?.addEventListener('click',close); overlay?.addEventListener('click',close);



  document.addEventListener('click',e=>{



    const btn=e.target.closest('[data-wishlist-toggle]');



    if(btn){e.preventDefault();e.stopPropagation();let items=read(),h=btn.dataset.productHandle;const ix=items.findIndex(i=>i.handle===h);if(ix>=0)items.splice(ix,1);else items.unshift({handle:h,title:btn.dataset.productTitle,url:btn.dataset.productUrl,image:btn.dataset.productImage,price:Number(btn.dataset.productPrice||0)});write(items);sync();return}



    const rem=e.target.closest('[data-wishlist-remove]');if(rem){let items=read().filter(i=>i.handle!==rem.dataset.wishlistRemove);write(items);sync()}



  });



  document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});



  sync();



})();







// v0.4 instant product-category tabs (AJAX-style UX without page reload)



(() => {



  const $$=(s,c=document)=>[...c.querySelectorAll(s)], $=(s,c=document)=>c.querySelector(s);



  $$('[data-product-tabs]').forEach(root=>{



    const tabs=$$('[data-product-tab]',root), panels=$$('[data-product-panel]',root);



    const activate=id=>{



      tabs.forEach(tab=>{



        const on=tab.dataset.productTab===id;



        tab.classList.toggle('is-active',on);



        tab.setAttribute('aria-selected',on?'true':'false');



      });



      panels.forEach(panel=>{



        const on=panel.dataset.productPanel===id;



        panel.hidden=!on;



        panel.classList.toggle('is-active',on);



        if(on){const track=$('[data-product-tabs-track]',panel);if(track)track.scrollLeft=0;}



      });



    };



    tabs.forEach(tab=>tab.addEventListener('click',()=>activate(tab.dataset.productTab)));



    root.addEventListener('click',e=>{



      const prev=e.target.closest('[data-product-tabs-prev]'), next=e.target.closest('[data-product-tabs-next]');



      if(!prev&&!next)return;



      const panel=$('[data-product-panel].is-active',root), track=panel&&$('[data-product-tabs-track]',panel);



      if(track)track.scrollBy({left:(next?1:-1)*Math.max(300,track.clientWidth*.82),behavior:'smooth'});



    });



  });



})();







// v0.4.4 product-page variant pills -> native Shopify variant select



(() => {



  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];



  document.addEventListener('click',e=>{



    const pill=e.target.closest('[data-product-variant-pill]');



    if(!pill || pill.classList.contains('is-disabled')) return;



    const root=pill.closest('[data-product-root]');



    if(!root) return;



    const select=$('[data-variant-select]',root), label=$('[data-selected-variant-label]',root);



    if(!select) return;



    select.value=pill.dataset.variantId;



    $$('[data-product-variant-pill]',root).forEach(x=>x.classList.toggle('is-active',x===pill));



    if(label) label.textContent=pill.dataset.variantLabel||pill.textContent.trim();



    select.dispatchEvent(new Event('change',{bubbles:true}));



  });



})();







// v0.4.9 — theme editor live refresh + product gallery/variant resilience



(() => {



  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];



  const money=(cents)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'es-MX',{style:'currency',currency:(window.PetPaw.currency||'MXN')}).format(Number(cents||0)/100)}catch(e){return '$'+(Number(cents||0)/100).toFixed(2)}};







  function showGalleryIndex(root,index){



    const items=$$('[data-gallery-item]',root), thumbs=$$('[data-gallery-thumb]',root); if(!items.length)return;



    index=(index+items.length)%items.length;



    items.forEach((item,i)=>{const on=i===index;item.hidden=!on;item.classList.toggle('is-active',on)});



    thumbs.forEach((thumb,i)=>thumb.classList.toggle('is-active',i===index));



    root.dataset.galleryIndex=String(index);



  }



  function showMediaId(productRoot,id){



    if(!id)return;const gallery=$('[data-product-gallery]',productRoot);if(!gallery)return;



    const items=$$('[data-gallery-item]',gallery), index=items.findIndex(x=>String(x.dataset.mediaId)===String(id));



    if(index>=0)showGalleryIndex(gallery,index);



  }



  function updateProductVariant(root,select){



    const json=$('[data-product-json]',root);if(!json||!select)return;let product;try{product=JSON.parse(json.textContent)}catch(e){return}



    const v=product.variants.find(x=>String(x.id)===String(select.value));if(!v)return;



    const price=$('[data-product-price]',root),button=$('[data-add-to-cart]',root),stock=$('[data-stock-state]',root),label=$('[data-selected-variant-label]',root);



    if(price)price.innerHTML=`${v.compare_at_price&&v.compare_at_price>v.price?`<s>${money(v.compare_at_price)}</s>`:''}<strong>${money(v.price)}</strong>`;



    if(button){button.disabled=!v.available;const span=$('span',button);if(span)span.textContent=v.available?'Añadir al carrito':'Agotado';else button.textContent=v.available?'Añadir al carrito':'Agotado'}



    if(stock){stock.classList.toggle('is-in',!!v.available);stock.classList.toggle('is-out',!v.available);const strong=$('strong',stock);if(strong)strong.textContent=v.available?'¡En stock!':'Agotado'}



    if(label)label.textContent=v.title;



    const mediaId=v.featured_media&&v.featured_media.id;showMediaId(root,mediaId);



    if(history.replaceState && !(window.Shopify&&Shopify.designMode)){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}



  }







  document.addEventListener('click',e=>{



    const thumb=e.target.closest('[data-gallery-thumb]');if(thumb){const gallery=thumb.closest('[data-product-gallery]');showGalleryIndex(gallery,Number(thumb.dataset.galleryThumb||0));return}



    const prev=e.target.closest('[data-gallery-prev]'),next=e.target.closest('[data-gallery-next]');if(prev||next){const gallery=(prev||next).closest('[data-product-gallery]');const i=Number(gallery.dataset.galleryIndex||0)+(next?1:-1);showGalleryIndex(gallery,i);return}



    const tab=e.target.closest('[data-product-tab]');if(tab){const root=tab.closest('[data-product-tabs]');if(root){const id=tab.dataset.productTab;$$('[data-product-tab]',root).forEach(t=>{const on=t.dataset.productTab===id;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on?'true':'false')});$$('[data-product-panel]',root).forEach(p=>{const on=p.dataset.productPanel===id;p.hidden=!on;p.classList.toggle('is-active',on)})}}



  });



  document.addEventListener('change',e=>{const select=e.target.closest('[data-variant-select]');if(!select)return;const root=select.closest('[data-product-root]');if(root)updateProductVariant(root,select)});







  function editorReady(scope){



    if(!(window.Shopify&&Shopify.designMode))return;



    document.body.classList.add('pp-design-mode');



    $$('[data-reveal]',scope||document).forEach(el=>el.classList.add('is-visible'));



    $$('img[loading="lazy"]',scope||document).forEach(img=>{img.loading='eager';img.decoding='async'});



  }



  editorReady(document);



  document.addEventListener('shopify:section:load',e=>{editorReady(e.target);requestAnimationFrame(()=>editorReady(e.target))});



  document.addEventListener('shopify:block:select',e=>editorReady(e.target));



})();







// PetPaw header popovers: Help + Account. Close on outside click/Escape and keep one open at a time.



(() => {



  const menus=[...document.querySelectorAll('[data-help-menu],[data-account-menu]')];



  if(!menus.length)return;



  menus.forEach(menu=>menu.addEventListener('toggle',()=>{



    if(!menu.open)return;



    menus.forEach(other=>{if(other!==menu&&other.open)other.removeAttribute('open')});



  }));



  document.addEventListener('click',e=>{



    menus.forEach(menu=>{if(menu.open&&!menu.contains(e.target))menu.removeAttribute('open')});



  });



  document.addEventListener('keydown',e=>{



    if(e.key!=='Escape')return;



    menus.forEach(menu=>{if(menu.open){menu.removeAttribute('open');menu.querySelector('summary')?.focus()}});



  });



})();
